import axios, { type AxiosRequestConfig } from "axios";
import { jwtDecode, type JwtPayload } from "jwt-decode";

export const ActivityLogin = async (token: string): Promise<void> => {
  const config: AxiosRequestConfig = {
    headers: {
      "content-type": "application/json",
      authorization: `Bearer ${token}`,
      "Ocp-Apim-Subscription-Key": import.meta.env.VITE_SUBSCRIPTION_KEY,
    },
  };

  const url = `${import.meta.env.VITE_ADMIN_API_BASE_URL}activities/login`;

  try {
    await axios.post(
      url,
      {
        email: jwtDecode<JwtPayload & { email: string }>(token)?.email ?? "",
        application: "AskAmi",
      },
      config,
    );
  } catch (error) {
    console.error("Error during login API call:", error);
  }
};
